<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / Master Files / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <button
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click="$refs.createEmploymentType.show()"
          v-if="role_modules.some(item => item.value == 'employment_type.create')"
        >
          <i class="uil-plus mr-1"></i> {{$t('employment_type.action.create_record')}}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
      <Table
        ref="list"
        :items="items"
        :useView="role_modules.some(item => item.value == 'employment_type.view')"
        :useEdit="role_modules.some(item => item.value == 'employment_type.edit')"
        :useDelete="true"
        noTitle
        :params="params"
        :fields="fields"
        :action="role_modules.some(item => item.value == 'employment_type') ? action : false"
        @openFormBar="openFormBar"
        @delete="onDeleteEmploymentType"
      />
      </div>
    </div>
    <Dialog
      centered
      title="View Employment Type"
      ref="viewEmploymentType"
      size="md"
      :component="viewComponent"
      :parameters="{ employment_typeID, submitted }" 
      v-if="role_modules.some(item => item.value == 'employment_type.view')"
    />
    <Dialog
      centered
      autoload
      is_reset_model
      title="Create Employment Type"
      ref="createEmploymentType"
      size="md"
      yesText="Create"
      noText="Cancel"
      :buttonDisable="created"
      :component="createComponent"
      @onYes="oncreateEmploymentType"
      v-if="role_modules.some(item => item.value == 'employment_type.create')"
    />
    <Dialog
      centered
      autoload
      title="Update Employment Type"
      ref="editEmploymentType"
      size="md"
      yesText="Update"
      noText="Cancel"
      :buttonDisable="updated"
      :component="editComponent"
      :parameters="{ employment_typeID, submitted }"
      @onYes="onUpdateEmploymentType"
      v-if="role_modules.some(item => item.value == 'employment_type.edit')"
    />
      <Dialog
      centered
      autoload
      title="Delete Employment Type"
      ref="deleteEmploymentType"
      size="md"
      yesText="Delete"
      noText="Cancel"
      :buttonDisable="deleted"
      :component="deleteComponent"
      :parameters="{employment_typeID, submitted }"
      @onYes="onDeleteEmploymentType"
    />
  </div>
</template>

<script>
import Table from '@components/table'
import moment from 'moment/moment'
import Dialog from '@components/offcanvas'
import createComponent from './components/dialogs/create.vue'
import viewComponent from './components/dialogs/view.vue'
import editComponent from './components/dialogs/edit.vue'
import deleteComponent from './components/dialogs/delete.vue'

import error from '@utils/error'

export default {
  components: {
    Table,
    Dialog
  },
  computed: {
    role_modules() {
      return this.$store.state.auth.role_modules || [];
    },
    createComponent () {
      return createComponent
    },
    viewComponent () {
      return viewComponent
    },
    editComponent () {
      return editComponent
    },
    deleteComponent () {
      return deleteComponent
    }
  },
  data() {
    return {
      fields: [
				{
          label: this.$t('employment_type.table.name'), 
          key:"name",
          sortable: true
        },
        {
          label: this.$t('employment_type.table.date_created'), 
          key:'date_created', formatter: (val) => moment(val).format('YYYY-MM-DD')
        },
        {
          key:'actions',
          label:''
        }
      ],
      params: {},
      action: 'employment_type/pagination',
      items:[],
      employment_typeID: '',
      submitted: false,
      created: false,
      updated: false,
      deleted: false,
    }
  },
  methods: {
    async fetchData() {
    try {
      const response = await this.$store.dispatch('employment_type/pagination', this.params);
      this.items = response.data.data; // Bind fetched data to the table
    } catch (error) {
      console.error('Error fetching employment types:', error);
    }
  },

    openFormBar(id, editMode = false, deleteMode = false) {
      this.employment_typeID = id;

      if (deleteMode) {
        this.$refs.deleteEmploymentType.show();
      } else if (editMode) {
        this.$refs.editEmploymentType.show();
      } else {
        this.$refs.viewEmploymentType.show();
      }
    },

    oncreateEmploymentType(val) {
      this.created = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('employment_type/create', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData();
          this.$refs.createEmploymentType.hide();
          this.$bvToast.toast('Employment Type successfully created!', {
            title: "Notification",
            variant: "success"
          });
          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    mounted() {
      this.fetchData();
    },

    onUpdateEmploymentType(val) {
      this.updated = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = model._id ? model._id : model.id ? model.id : ''

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.updated = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('employment_type/update', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData()
          this.$refs.editEmploymentType.hide()
          this.submitted = !this.submitted
          this.$bvToast.toast(`Employment Types successfully updated!`, {
            title: "Notification",
            variant: 'success'
          })
          setTimeout(() => {
            this.updated = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.updated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    
    onDeleteEmploymentType(val) {
      if (typeof val === 'string') {
        this.employment_typeID = val;
        if (this.$refs.deleteEmploymentType) {
          this.$refs.deleteEmploymentType.show();
        }
        return;
      }
      
      this.deleted = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val;
      
      if (!model.id && !model._id && this.employment_typeID) {
        model.id = this.employment_typeID;
      } else {
        model.id = model._id ? model._id : model.id ? model.id : '';
      }

      return this.$store.dispatch('employment_type/delete', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData();
          if (this.$refs.deleteEmploymentType) {
            this.$refs.deleteEmploymentType.hide();
          }
          this.submitted = !this.submitted;
          this.$bvToast.toast(`Employment Type successfully deleted!`, {
            title: "Notification",
            variant: 'success'
          });
          setTimeout(() => {
            this.deleted = false;
          }, 1500);
        }
      })
      .catch(err => {
        this.deleted = false;
        return error.errorHandler(err, this.$bvToast);
      });
    },
  },
}
</script>